(function () {
  'use strict'

  const ayar = window.BayiAyar
  if (!ayar || !ayar.api) return

  const JETON = 'bayi_jeton'
  const BILGI = 'bayi_bilgi'
  const TUR = 'bayi_tur'
  const ESITLEME = 'bayi_esitleme'
  const YENILEME = 'bayi_yenileme'
  const SEPET_IMZA = 'bayi_sepet_imza'
  const ESITLEME_ARALIGI = 10 * 60 * 1000
  const YOKLAMA_ARALIGI = 4000
  const EN_FAZLA_BELGE = 5 * 1024 * 1024
  const kok = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'
  const paraBicimi = new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  const tarihSaatBicimi = new Intl.DateTimeFormat('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
  const tarihBicimi = new Intl.DateTimeFormat('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric' })

  function para(kurus) {
    return paraBicimi.format((Number(kurus) || 0) / 100) + ' TL'
  }

  function yuzde(oran) {
    return '%' + String(Number(((Number(oran) || 0) / 100).toFixed(2))).replace('.', ',')
  }

  function depoAl(depo, anahtar) {
    try {
      return depo.getItem(anahtar)
    } catch (hata) {
      return null
    }
  }

  function depoYaz(depo, anahtar, deger) {
    try {
      depo.setItem(anahtar, deger)
    } catch (hata) {
      return
    }
  }

  function depoSil(depo, anahtar) {
    try {
      depo.removeItem(anahtar)
    } catch (hata) {
      return
    }
  }

  function jeton() {
    return depoAl(localStorage, JETON)
  }

  function bilgiAl() {
    try {
      return JSON.parse(depoAl(localStorage, BILGI) || 'null')
    } catch (hata) {
      return null
    }
  }

  function bilgiYaz(bayi) {
    depoYaz(localStorage, BILGI, JSON.stringify(bayi))
  }

  function musteriMi() {
    return Boolean(jeton()) && depoAl(localStorage, TUR) === 'musteri'
  }

  function bayiMi() {
    return Boolean(jeton()) && !musteriMi()
  }

  async function api(yol, secenekler) {
    const s = secenekler || {}
    const basliklar = {}
    if (s.govde) basliklar['Content-Type'] = 'application/json'
    if (s.jetonlu) basliklar.Authorization = 'Bearer ' + jeton()
    let yanit
    try {
      yanit = await fetch(ayar.api + '/vitrin' + yol, {
        method: s.yontem || 'GET',
        headers: basliklar,
        body: s.form || (s.govde ? JSON.stringify(s.govde) : undefined)
      })
    } catch (hata) {
      throw new Error('Sunucuya ulaşılamadı. Lütfen bağlantınızı kontrol edip tekrar deneyin.')
    }
    if (s.ham && yanit.ok) return yanit
    let veri = null
    try {
      veri = await yanit.json()
    } catch (hata) {
      veri = null
    }
    if (!yanit.ok) {
      const hata = new Error((veri && veri.hata) || 'İşlem tamamlanamadı. Lütfen tekrar deneyin.')
      hata.durum = yanit.status
      throw hata
    }
    return veri
  }

  async function sepetAl() {
    const yanit = await fetch(kok + 'cart.js', { headers: { Accept: 'application/json' } })
    return yanit.json()
  }

  function sepetGuncelle(govde) {
    return fetch(kok + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(govde)
    })
  }

  function nitelikYaz(deger) {
    return sepetGuncelle({ attributes: { _bayi: deger } })
  }

  function yenile() {
    const simdi = Date.now()
    const kayit = (depoAl(sessionStorage, YENILEME) || '').split(',').map(Number).filter((z) => simdi - z < 60000)
    if (kayit.length >= 2) return false
    kayit.push(simdi)
    depoYaz(sessionStorage, YENILEME, kayit.join(','))
    window.location.reload()
    return true
  }

  function imzaIcerigi(imza) {
    return String(imza || '').split('|').slice(2, 6).join('|')
  }

  function girisAdresi() {
    return ayar.sayfalar.giris + '?donus=' + encodeURIComponent(window.location.pathname + window.location.search)
  }

  async function oturumuKapat(hedef) {
    depoSil(localStorage, JETON)
    depoSil(localStorage, BILGI)
    depoSil(localStorage, TUR)
    depoSil(sessionStorage, ESITLEME)
    try {
      await nitelikYaz('')
    } catch (hata) {
      console.error(hata)
    }
    if (hedef) window.location.href = hedef
  }

  async function oturumAc(veri) {
    depoYaz(localStorage, JETON, veri.jeton)
    depoYaz(sessionStorage, ESITLEME, String(Date.now()))
    if (veri.tur === 'musteri') {
      depoYaz(localStorage, TUR, 'musteri')
      bilgiYaz(veri.hesap)
      if (ayar.oturum) await nitelikYaz('')
      return
    }
    depoSil(localStorage, TUR)
    bilgiYaz(veri.bayi)
    await nitelikYaz(veri.imza)
  }

  async function musteriEsitle(zorla) {
    if (ayar.oturum) {
      await nitelikYaz('')
      if (yenile()) return 'yenilendi'
    }
    const son = Number(depoAl(sessionStorage, ESITLEME) || 0)
    if (!zorla && Date.now() - son < ESITLEME_ARALIGI) return true
    try {
      const veri = await api('/hesap', { jetonlu: true })
      depoYaz(sessionStorage, ESITLEME, String(Date.now()))
      bilgiYaz(veri.hesap)
    } catch (hata) {
      if (hata.durum === 401) await oturumuKapat(null)
    }
    return true
  }

  async function esitle(zorla) {
    if (!jeton()) {
      if (ayar.oturum) {
        await nitelikYaz('')
        yenile()
        return 'yenilendi'
      }
      return false
    }
    if (musteriMi()) return musteriEsitle(zorla)
    const son = Number(depoAl(sessionStorage, ESITLEME) || 0)
    if (!zorla && ayar.oturum && Date.now() - son < ESITLEME_ARALIGI) return true
    let mevcut = ''
    try {
      const sepet = await sepetAl()
      mevcut = (sepet.attributes && sepet.attributes._bayi) || ''
    } catch (hata) {
      mevcut = ''
    }
    let veri
    try {
      veri = await api('/oturum?mevcut=' + encodeURIComponent(mevcut), { jetonlu: true })
    } catch (hata) {
      if (hata.durum === 401) {
        await oturumuKapat(null)
        if (ayar.oturum) {
          yenile()
          return 'yenilendi'
        }
        return false
      }
      return Boolean(ayar.oturum)
    }
    depoYaz(sessionStorage, ESITLEME, String(Date.now()))
    bilgiYaz(veri.bayi)
    if (veri.imza !== mevcut) {
      await nitelikYaz(veri.imza)
      if (!ayar.oturum || imzaIcerigi(veri.imza) !== imzaIcerigi(mevcut)) {
        if (yenile()) return 'yenilendi'
      }
    }
    return true
  }

  let yoklaniyor = false
  let yoklamaBitti = false

  async function yokla() {
    if (yoklaniyor || yoklamaBitti || !ayar.oturum || !bayiMi() || document.visibilityState !== 'visible') return
    yoklaniyor = true
    try {
      const veri = await api('/nabiz?icerik=' + encodeURIComponent(ayar.oturum), { jetonlu: true })
      if (veri.degisti) {
        await nitelikYaz(veri.imza)
        depoYaz(sessionStorage, ESITLEME, String(Date.now()))
        if (!yenile()) yoklamaBitti = true
      }
    } catch (hata) {
      if (hata.durum === 401) {
        await oturumuKapat(null)
        if (!yenile()) yoklamaBitti = true
      }
    } finally {
      yoklaniyor = false
    }
  }

  function yoklamayiBaslat() {
    if (!ayar.oturum || !bayiMi()) return
    setInterval(yokla, YOKLAMA_ARALIGI)
    document.addEventListener('visibilitychange', yokla)
    window.addEventListener('focus', yokla)
    window.addEventListener('pageshow', yokla)
    yokla()
  }

  let sepetZamanlayici = null

  async function sepetEsitle() {
    if (!ayar.oturum || !bayiMi()) return
    let sepet
    try {
      sepet = await sepetAl()
    } catch (hata) {
      return
    }
    const kalemler = (sepet.items || []).map((k) => ({ variantId: String(k.variant_id), adet: k.quantity }))
    const bilgi = bilgiAl()
    const imza = ((bilgi && bilgi.kod) || '') + '|' + kalemler.map((k) => k.variantId + ':' + k.adet).sort().join(',')
    if (imza === depoAl(localStorage, SEPET_IMZA)) return
    try {
      await api('/sepet', { yontem: 'POST', jetonlu: true, govde: { kalemler } })
      depoYaz(localStorage, SEPET_IMZA, imza)
    } catch (hata) {
      return
    }
  }

  function sepetEsitlemeyiZamanla() {
    clearTimeout(sepetZamanlayici)
    sepetZamanlayici = setTimeout(sepetEsitle, 800)
  }

  function sepetiIzle() {
    if (!ayar.oturum || !bayiMi()) return
    const asil = window.fetch
    window.fetch = function (girdi) {
      const soz = asil.apply(this, arguments)
      const adres = typeof girdi === 'string' ? girdi : (girdi && girdi.url) || ''
      if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(adres)) soz.then(sepetEsitlemeyiZamanla, () => null)
      return soz
    }
    window.addEventListener('pageshow', sepetEsitlemeyiZamanla)
    sepetEsitlemeyiZamanla()
  }

  function mesajGoster(kap, metin, secici) {
    const kutu = kap.querySelector(secici || '[data-bayi-mesaj]')
    if (!kutu) return
    kutu.textContent = metin || ''
    kutu.hidden = !metin
    if (metin) kutu.scrollIntoView({ block: 'nearest', behavior: 'smooth' })
  }

  function mesgul(form, durum) {
    const dugme = form.querySelector('[type="submit"]')
    if (dugme) dugme.disabled = durum
  }

  function donusAdresi(varsayilan) {
    const deger = new URLSearchParams(window.location.search).get('donus') || ''
    return /^\/(?!\/)/.test(deger) ? deger : varsayilan || kok
  }

  function girisSayfasi() {
    return /\/pages\/(bayi-)?giris\/?$/.test(window.location.pathname)
  }

  function turkiyeMi(ulke) {
    const ad = String(ulke || '').trim().toLocaleLowerCase('tr')
    return ad === '' || ['türkiye', 'turkiye', 'turkey', 'tr'].includes(ad)
  }

  function oge(etiket, ozellikler, cocuklar) {
    const dugum = document.createElement(etiket)
    Object.entries(ozellikler || {}).forEach(([ad, deger]) => {
      if (deger === false || deger === null || deger === undefined) return
      if (ad === 'metin') dugum.textContent = deger
      else if (ad === 'sinif') dugum.className = deger
      else if (deger === true) dugum.setAttribute(ad, '')
      else dugum.setAttribute(ad, deger)
    })
    ;(cocuklar || []).forEach((cocuk) => {
      if (cocuk) dugum.appendChild(typeof cocuk === 'string' ? document.createTextNode(cocuk) : cocuk)
    })
    return dugum
  }

  const formIsleyicileri = {
    async giris(form) {
      const email = form.elements.email.value.trim()
      const sifre = form.elements.sifre.value
      if (!email || !sifre) throw new Error('E-posta ve şifrenizi yazın.')
      const veri = await api('/giris', { yontem: 'POST', govde: { email, sifre } })
      await oturumAc(veri)
      if (girisSayfasi()) window.location.href = donusAdresi(veri.tur === 'musteri' ? ayar.sayfalar.hesabim : kok)
      else window.location.reload()
    },

    async kayit(form) {
      const e = form.elements
      const govde = {
        ad: e.ad.value.trim(),
        soyad: e.soyad.value.trim(),
        email: e.email.value.trim(),
        telefon: e.telefon.value.trim(),
        sifre: e.sifre.value,
        onay: e.onay.checked,
        pazarlamaIzni: e.pazarlamaIzni.checked
      }
      if (!govde.ad || !govde.soyad || !govde.email) throw new Error('Yıldızlı alanları doldurun.')
      if (govde.sifre.length < 8) throw new Error('Şifre en az 8 karakter olmalıdır.')
      if (govde.sifre !== e.sifre2.value) throw new Error('Şifreler birbiriyle aynı değil.')
      if (!govde.onay) throw new Error('Devam etmek için aydınlatma metnini onaylayın.')
      const veri = await api('/kayit', { yontem: 'POST', govde })
      await oturumAc(veri)
      window.location.href = ayar.sayfalar.hesabim + '?hosgeldin=1'
    },

    async basvuru(form) {
      const e = form.elements
      const veri = new FormData()
      const deger = {}
      ;['firma', 'yetkili', 'email', 'telefon', 'vergiDairesi', 'vergiNo', 'adres', 'il', 'ulke', 'not'].forEach((ad) => {
        deger[ad] = e[ad].value.trim()
        veri.append(ad, deger[ad])
      })
      const sifre = e.sifre.value
      if (!deger.firma || !deger.yetkili || !deger.email || !deger.telefon) throw new Error('Yıldızlı alanları doldurun.')
      if (turkiyeMi(deger.ulke) && ![10, 11].includes(deger.vergiNo.replace(/\D/g, '').length)) {
        throw new Error('Vergi numarası 10 haneli, T.C. kimlik numarası 11 haneli olmalıdır.')
      }
      if (sifre.length < 6) throw new Error('Şifre en az 6 karakter olmalıdır.')
      if (sifre !== e.sifre2.value) throw new Error('Şifreler birbiriyle aynı değil.')
      if (!e.onay.checked) throw new Error('Devam etmek için aydınlatma metnini onaylayın.')
      veri.append('sifre', sifre)
      const dosya = e.belge && e.belge.files && e.belge.files[0]
      if (dosya) {
        if (dosya.size > EN_FAZLA_BELGE) throw new Error('Vergi levhası dosyası en fazla 5 MB olabilir.')
        veri.append('belge', dosya)
      }
      await api('/basvuru', { yontem: 'POST', form: veri })
      const bolum = form.closest('[data-bayi-bolum]')
      form.hidden = true
      const basarili = bolum.querySelector('[data-bayi-basarili]')
      basarili.hidden = false
      basarili.scrollIntoView({ block: 'center', behavior: 'smooth' })
    },

    async 'sifre-talep'(form) {
      const email = form.elements.email.value.trim()
      if (!email) throw new Error('E-posta adresinizi yazın.')
      await api('/sifre-talep', { yontem: 'POST', govde: { email } })
      const bolum = form.closest('[data-bayi-bolum]')
      form.hidden = true
      const basarili = bolum.querySelector('[data-bayi-basarili]')
      basarili.textContent = 'Bu adres kayıtlı bir hesaba aitse şifre yenileme bağlantısı e-posta ile gönderildi. Gelen kutunuzu ve gereksiz klasörünü kontrol edin.'
      basarili.hidden = false
    },

    async 'sifre-yenile'(form) {
      const sifre = form.elements.sifre.value
      if (sifre.length < 6) throw new Error('Şifre en az 6 karakter olmalıdır.')
      if (sifre !== form.elements.sifre2.value) throw new Error('Şifreler birbiriyle aynı değil.')
      const token = new URLSearchParams(window.location.search).get('token') || ''
      await api('/sifre-yenile', { yontem: 'POST', govde: { token, sifre } })
      await oturumuKapat(null)
      const bolum = form.closest('[data-bayi-bolum]')
      form.hidden = true
      const basarili = bolum.querySelector('[data-bayi-basarili]')
      basarili.textContent = 'Şifreniz yenilendi. Yeni şifrenizle giriş yapabilirsiniz.'
      basarili.hidden = false
    }
  }

  document.addEventListener('submit', async (olay) => {
    const form = olay.target.closest('[data-bayi-form]')
    if (!form) return
    olay.preventDefault()
    const isleyici = formIsleyicileri[form.dataset.bayiForm]
    if (!isleyici) return
    mesajGoster(form, '')
    mesgul(form, true)
    try {
      await isleyici(form)
    } catch (hata) {
      mesajGoster(form, hata.message)
    } finally {
      mesgul(form, false)
    }
  })

  function adresMetni(a) {
    return [a.alici, a.adres, a.ilce, a.il, a.ulke].filter(Boolean).join(', ')
  }

  function adresSec(adresler) {
    return new Promise((coz) => {
      const secenekler = adresler.map((a) =>
        oge('label', { sinif: 'bayi-secenek' }, [
          oge('input', { type: 'radio', name: 'bayi-adres', value: a.id, checked: a.varsayilan }),
          oge('span', {}, [oge('b', { metin: a.baslik }), oge('span', { metin: adresMetni(a) })])
        ])
      )
      const vazgec = oge('button', { type: 'button', sinif: 'hdt-btn hdt-btn-outline' }, [oge('span', { metin: 'Vazgeç' })])
      const devam = oge('button', { type: 'button', sinif: 'hdt-btn hdt-btn-solid' }, [oge('span', { metin: 'Siparişi oluştur' })])
      const pencere = oge('dialog', { sinif: 'bayi-pencere', 'aria-label': 'Teslimat adresi' }, [
        oge('h2', { sinif: 'hdt-heading hdt-h5', metin: 'Teslimat adresi' }),
        oge('p', { sinif: 'hdt-s-text', metin: 'Bu sipariş hangi adrese teslim edilecek?' }),
        oge('div', { sinif: 'bayi-secenekler' }, secenekler),
        oge('div', { sinif: 'bayi-pencere__alt' }, [vazgec, devam])
      ])
      let sonuc = null
      document.body.appendChild(pencere)
      if (!pencere.querySelector('input:checked')) pencere.querySelector('input').checked = true
      vazgec.addEventListener('click', () => pencere.close())
      devam.addEventListener('click', () => {
        sonuc = pencere.querySelector('input:checked').value
        pencere.close()
      })
      pencere.addEventListener('close', () => {
        pencere.remove()
        coz(sonuc)
      })
      pencere.showModal()
    })
  }

  function odemeSec(secenekler) {
    return new Promise((coz) => {
      const ilkUygun = secenekler.find((s) => s.uygun)
      const satirlar = secenekler.map((s) =>
        oge('label', { sinif: 'bayi-secenek' + (s.uygun ? '' : ' bayi-secenek--kapali') }, [
          oge('input', { type: 'radio', name: 'bayi-odeme', value: s.kod, checked: ilkUygun && ilkUygun.kod === s.kod, disabled: !s.uygun }),
          oge('span', {}, [
            oge('b', { metin: s.ad }),
            oge('span', { sinif: 'bayi-secenek__tutar', metin: 'Ödeyeceğiniz tutar: ' + para(s.toplam) }),
            oge('span', { metin: s.uygun ? 'Liste fiyatı ' + para(s.listeToplam) + ' ÷ ' + s.katsayiMetni + (s.iskontoToplam ? ' · iskonto -' + para(s.iskontoToplam) : '') : s.uyari })
          ])
        ])
      )
      const vazgec = oge('button', { type: 'button', sinif: 'hdt-btn hdt-btn-outline' }, [oge('span', { metin: 'Vazgeç' })])
      const devam = oge('button', { type: 'button', sinif: 'hdt-btn hdt-btn-solid', disabled: !ilkUygun }, [oge('span', { metin: 'Devam et' })])
      const pencere = oge('dialog', { sinif: 'bayi-pencere', 'aria-label': 'Ödeme yöntemi' }, [
        oge('h2', { sinif: 'hdt-heading hdt-h5', metin: 'Ödeme yöntemi' }),
        oge('p', { sinif: 'hdt-s-text', metin: 'Bu siparişin ödemesini nasıl yapacaksınız? Proformada seçtiğiniz yönteme göre ödeyeceğiniz tutar yazar. Sitede ödeme alınmaz.' }),
        oge('div', { sinif: 'bayi-secenekler' }, satirlar),
        oge('div', { sinif: 'bayi-pencere__alt' }, [vazgec, devam])
      ])
      let sonuc = null
      document.body.appendChild(pencere)
      vazgec.addEventListener('click', () => pencere.close())
      devam.addEventListener('click', () => {
        const secili = pencere.querySelector('input:checked')
        sonuc = secili ? secili.value : null
        pencere.close()
      })
      pencere.addEventListener('close', () => {
        pencere.remove()
        coz(sonuc)
      })
      pencere.showModal()
    })
  }

  function proformaMesaji(dugme, metin) {
    const kap = dugme.parentElement
    let kutu = kap.querySelector('[data-bayi-proforma-mesaj]')
    if (!kutu) {
      kutu = oge('p', { sinif: 'bayi-proforma-mesaj', 'data-bayi-proforma-mesaj': true, role: 'alert' })
      dugme.insertAdjacentElement('afterend', kutu)
    }
    kutu.textContent = metin || ''
    kutu.hidden = !metin
  }

  async function proformaOlustur(dugme) {
    const metinAlani = dugme.querySelector('[data-bayi-proforma-metin]')
    const eskiMetin = metinAlani ? metinAlani.textContent : ''
    const geriAl = () => {
      dugme.disabled = false
      if (metinAlani) metinAlani.textContent = eskiMetin
    }
    dugme.disabled = true
    if (metinAlani) metinAlani.textContent = 'Sipariş oluşturuluyor…'
    proformaMesaji(dugme, '')
    try {
      if (!jeton()) {
        window.location.href = girisAdresi()
        return
      }
      const durum = await esitle(true)
      if (durum === 'yenilendi') return
      if (!durum) {
        window.location.href = girisAdresi()
        return
      }
      const sepet = await sepetAl()
      if (!sepet.items || !sepet.items.length) throw new Error('Sepetiniz boş.')
      const kalemler = sepet.items.map((kalem) => ({ variantId: String(kalem.variant_id), adet: kalem.quantity }))
      const profil = await api('/profil', { jetonlu: true })
      bilgiYaz(profil.bayi)
      let odemeYontemi = null
      if ((profil.bayi.odemeYontemleri || []).length) {
        const onizleme = await api('/siparisler/onizleme', { yontem: 'POST', jetonlu: true, govde: { kalemler } })
        odemeYontemi = await odemeSec(onizleme.secenekler || [])
        if (!odemeYontemi) {
          geriAl()
          return
        }
      }
      const adresler = profil.bayi.adresler || []
      let adresId = adresler.length === 1 ? adresler[0].id : null
      if (adresler.length > 1) {
        adresId = await adresSec(adresler)
        if (!adresId) {
          geriAl()
          return
        }
      }
      const notAlani = document.querySelector('textarea[name="note"]')
      const veri = await api('/siparisler', {
        yontem: 'POST',
        jetonlu: true,
        govde: {
          kalemler,
          not: notAlani ? notAlani.value : sepet.note || '',
          adresId,
          odemeYontemi
        }
      })
      await fetch(kok + 'cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } })
      await sepetGuncelle({ note: '' })
      window.location.href = ayar.sayfalar.hesabim + '?siparis=' + encodeURIComponent(veri.siparis.no) + '&yeni=1'
    } catch (hata) {
      proformaMesaji(dugme, hata.message)
      geriAl()
    }
  }

  function kuralMetni() {
    const bilgi = bilgiAl()
    const kural = bilgi && bilgi.kural
    const parcalar = []
    if (kural && (kural.minTutar || kural.minAdet)) {
      parcalar.push('Minimum sipariş: ' + [kural.minTutar ? para(kural.minTutar) : null, kural.minAdet ? kural.minAdet + ' adet' : null].filter(Boolean).join(' · '))
    }
    const yontemler = (bilgi && bilgi.odemeYontemleri) || []
    if (yontemler.length) parcalar.push('Ödeme yöntemini (' + yontemler.map((y) => y.ad.toLocaleLowerCase('tr')).join(', ') + ') sonraki adımda seçersiniz; ödeyeceğiniz tutar seçiminize göre hesaplanır.')
    return parcalar.join(' ')
  }

  function kuralNotlariniYaz() {
    const metin = kuralMetni()
    document.querySelectorAll('[data-bayi-proforma]').forEach((dugme) => {
      const mevcut = dugme.parentElement.querySelector('[data-bayi-kural]')
      if (!metin) {
        if (mevcut) mevcut.remove()
        return
      }
      if (mevcut) {
        if (mevcut.textContent !== metin) mevcut.textContent = metin
        return
      }
      dugme.insertAdjacentElement('afterend', oge('p', { sinif: 'bayi-proforma-bilgi', 'data-bayi-kural': true, metin }))
    })
  }

  function odemeGirisimi(hedef) {
    if (!bayiMi() || !hedef || !hedef.closest) return false
    if (hedef.closest('[name="checkout"], [data-shopify="payment-button"], .shopify-payment-button')) return true
    const baglanti = hedef.closest('a[href]')
    return Boolean(baglanti && /\/checkouts?(\/|\?|$)/.test(baglanti.getAttribute('href')))
  }

  function sepeteCevir(olay) {
    olay.preventDefault()
    olay.stopPropagation()
    window.location.href = kok + 'cart'
  }

  document.addEventListener(
    'click',
    (olay) => {
      if (odemeGirisimi(olay.target)) sepeteCevir(olay)
    },
    true
  )

  function uyeOdemeAdresi() {
    const b = bilgiAl() || {}
    const adresler = b.adresler || []
    const a = adresler.find((x) => x.varsayilan) || adresler[0] || {}
    const p = new URLSearchParams()
    const ekle = (ad, deger) => {
      if (deger) p.set(ad, deger)
    }
    ekle('checkout[email]', b.email)
    ekle('checkout[shipping_address][first_name]', a.ad || b.ad)
    ekle('checkout[shipping_address][last_name]', a.soyad || b.soyad)
    ekle('checkout[shipping_address][address1]', a.adres)
    ekle('checkout[shipping_address][address2]', a.ilce)
    ekle('checkout[shipping_address][city]', a.il)
    ekle('checkout[shipping_address][zip]', a.postaKodu)
    if (a.adres && turkiyeMi(a.ulke)) p.set('checkout[shipping_address][country]', 'TR')
    return kok + 'checkout?' + p.toString()
  }

  document.addEventListener(
    'submit',
    (olay) => {
      const dugme = olay.submitter
      if (!dugme || dugme.getAttribute('name') !== 'checkout') return
      if (bayiMi()) {
        sepeteCevir(olay)
        return
      }
      if (!musteriMi()) return
      olay.preventDefault()
      olay.stopPropagation()
      const form = olay.target
      dugme.disabled = true
      fetch(form.getAttribute('action') || kok + 'cart', { method: 'POST', body: new FormData(form) })
        .catch(() => null)
        .then(() => {
          window.location.href = uyeOdemeAdresi()
        })
    },
    true
  )

  document.addEventListener('click', (olay) => {
    const proforma = olay.target.closest('[data-bayi-proforma]')
    if (proforma) {
      olay.preventDefault()
      if (!proforma.disabled) proformaOlustur(proforma)
      return
    }
    if (olay.target.closest('[data-bayi-cikis]')) {
      olay.preventDefault()
      oturumuKapat(kok)
    }
  })

  function rozet(siparis) {
    return oge('span', { sinif: 'bayi-rozet bayi-rozet--' + siparis.durum, metin: siparis.durumAdi })
  }

  function tablo(basliklar, satirlar) {
    return oge('div', { sinif: 'bayi-tablo-sarici' }, [
      oge('table', { sinif: 'bayi-tablo' }, [
        oge('thead', {}, [oge('tr', {}, basliklar.map((b) => oge('th', { sinif: b.sag ? 'bayi-sag' : '', metin: b.ad })))]),
        oge('tbody', {}, satirlar)
      ])
    ])
  }

  function alan(etiket, girdi, not) {
    const kimlik = 'Bayi-' + Math.random().toString(36).slice(2, 9)
    girdi.id = kimlik
    return oge('div', { sinif: 'bayi-alan' + (girdi.dataset.tam ? ' bayi-alan--tam' : '') }, [oge('label', { for: kimlik, metin: etiket }), girdi, not ? oge('small', { metin: not }) : null])
  }

  function girdi(ad, deger, ek) {
    return oge('input', Object.assign({ sinif: 'hdt-input', type: 'text', name: ad, value: deger || '' }, ek || {}))
  }

  function hesabim(bolum) {
    if (musteriMi()) {
      musteriHesabi(bolum)
      return
    }
    const icerik = bolum.querySelector('[data-bayi-icerik]')
    const sekmeler = bolum.querySelectorAll('[data-bayi-sekme]')
    let bilgi = bilgiAl()

    function doldur(dugumler) {
      icerik.replaceChildren(...dugumler.filter(Boolean))
    }

    function temizle() {
      mesajGoster(bolum, '')
      mesajGoster(bolum, '', '[data-bayi-bilgi]')
    }

    function basari(metin) {
      mesajGoster(bolum, metin, '[data-bayi-bilgi]')
    }

    function yukleniyor() {
      doldur([oge('p', { sinif: 'bayi-yukleniyor hdt-s-text', metin: 'Yükleniyor…' })])
    }

    async function hataIsle(hata) {
      if (hata.durum === 401) {
        await oturumuKapat(ayar.sayfalar.giris)
        return
      }
      mesajGoster(bolum, hata.message)
    }

    function kunyeYaz() {
      if (!bilgi) return
      bolum.querySelector('[data-bayi-firma]').textContent = bilgi.firma
      bolum.querySelector('[data-bayi-kunye]').textContent = bilgi.yetkili + ' · Bayi kodu ' + bilgi.kod
      const kutu = bolum.querySelector('[data-bayi-temsilci]')
      const t = bilgi.temsilci
      if (!t) {
        kutu.hidden = true
        return
      }
      const rakam = String(t.telefon || '').replace(/\D/g, '')
      const uluslararasi = rakam.length === 11 && rakam.startsWith('0') ? '9' + rakam : rakam.length === 10 ? '90' + rakam : rakam
      kutu.replaceChildren(
        ...[
          oge('span', { sinif: 'bayi-temsilci__etiket', metin: 'Müşteri temsilciniz' }),
          oge('b', { metin: t.ad }),
          t.telefon ? oge('a', { sinif: 'hdt-link-underline', href: 'tel:+' + uluslararasi, metin: t.telefon }) : null,
          uluslararasi ? oge('a', { sinif: 'hdt-link-underline', href: 'https://wa.me/' + uluslararasi, target: '_blank', rel: 'noopener', metin: 'WhatsApp' }) : null,
          t.email ? oge('a', { sinif: 'hdt-link-underline', href: 'mailto:' + t.email, metin: t.email }) : null
        ].filter(Boolean)
      )
      kutu.hidden = false
    }

    function oranlar() {
      if (!bilgi) return null
      const satirlar = [oge('li', {}, ['Genel iskonto ', oge('b', { metin: yuzde(bilgi.genelIskonto) })])]
      ;(bilgi.kategoriIskontolari || []).forEach((k) => {
        satirlar.push(oge('li', {}, [k.ad + ' ', oge('b', { metin: yuzde(k.oran) })]))
      })
      const kural = kuralMetni()
      if (kural) satirlar.push(oge('li', { metin: kural }))
      return oge('ul', { sinif: 'bayi-oranlar' }, satirlar)
    }

    async function profilYukle() {
      const veri = await api('/profil', { jetonlu: true })
      bilgi = veri.bayi
      bilgiYaz(bilgi)
      kunyeYaz()
      return bilgi
    }

    async function pdfIndir(no, dugme) {
      dugme.disabled = true
      try {
        const yanit = await api('/siparisler/' + encodeURIComponent(no) + '/pdf', { jetonlu: true, ham: true })
        const adres = URL.createObjectURL(await yanit.blob())
        const baglanti = oge('a', { href: adres, download: 'Proforma-' + no + '.pdf' })
        document.body.appendChild(baglanti)
        baglanti.click()
        baglanti.remove()
        setTimeout(() => URL.revokeObjectURL(adres), 60000)
      } catch (hata) {
        hataIsle(hata)
      } finally {
        dugme.disabled = false
      }
    }

    function adimCizelgesi(s) {
      if (s.durum === 'iptal') {
        return oge('div', { sinif: 'bayi-uyari bayi-uyari--hata', metin: 'Bu sipariş iptal edildi.' + (s.iptalNedeni ? ' Neden: ' + s.iptalNedeni : '') })
      }
      return oge(
        'ol',
        { sinif: 'bayi-adimlar' },
        s.adimlar.map((a) => oge('li', { sinif: a.tamam ? 'tamam' : '' }, [oge('b', { metin: a.ad }), a.tamam && a.tarih ? oge('span', { metin: tarihBicimi.format(new Date(a.tarih)) }) : null]))
      )
    }

    function bilgiKutulari(s) {
      const kutular = []
      if (s.sevk && (s.sevk.firma || s.sevk.takipNo || s.sevk.takipUrl || s.sevk.not)) {
        kutular.push(
          oge('div', { sinif: 'bayi-kutu-bilgi' }, [
            oge('b', { metin: 'Sevk bilgisi' }),
            s.sevk.firma ? oge('span', { metin: 'Kargo firması: ' + s.sevk.firma }) : null,
            s.sevk.takipNo ? oge('span', { metin: 'Takip numarası: ' + s.sevk.takipNo }) : null,
            s.sevk.not ? oge('span', { metin: 'Not: ' + s.sevk.not }) : null,
            s.sevk.takipUrl && /^https?:\/\//i.test(s.sevk.takipUrl) ? oge('a', { sinif: 'hdt-link-underline', href: s.sevk.takipUrl, target: '_blank', rel: 'noopener', metin: 'Kargoyu takip et' }) : null
          ])
        )
      }
      if (s.teslimat && s.teslimat.adres) {
        kutular.push(
          oge('div', { sinif: 'bayi-kutu-bilgi' }, [
            oge('b', { metin: 'Teslimat adresi' + (s.teslimat.baslik ? ' — ' + s.teslimat.baslik : '') }),
            oge('span', { metin: adresMetni(s.teslimat) }),
            s.teslimat.telefon ? oge('span', { metin: s.teslimat.telefon }) : null
          ])
        )
      }
      return kutular.length ? oge('div', { sinif: 'bayi-kutular' }, kutular) : null
    }

    function kalemGovdesi(kalemler) {
      return kalemler.map((k) => ({ variantId: k.variantId, adet: k.adet }))
    }

    async function siparisGonder(s, veri, dugme) {
      temizle()
      dugme.disabled = true
      try {
        await api('/siparisler/' + encodeURIComponent(s.no) + '/duzenle', { yontem: 'POST', jetonlu: true, govde: Object.assign({ revizyon: s.revizyon }, veri) })
        await detayGoster(s.no)
        basari(s.durum === 'bayi_onayi' ? 'Siparişi onayladınız ve ekibimize iletildi. Onaylandığında size haber vereceğiz.' : 'Değişiklikleriniz kaydedildi ve ekibimize iletildi.')
      } catch (hata) {
        dugme.disabled = false
        await hataIsle(hata)
      }
    }

    function duzenlemeGoster(s) {
      temizle()
      const taslak = s.durum === 'bayi_onayi'
      const yontemler = s.odemeYontemleri || []
      let secili = s.odemeYontemi
      const kalemler = s.kalemler.map((k) => ({ variantId: k.variantId, urunAd: k.urunAd, varyantAd: k.varyantAd, sku: k.sku, listeFiyat: k.listeFiyat, oran: k.iskontoOrani, adet: k.adet }))
      const govde = oge('tbody')
      const toplamAlani = oge('div', { sinif: 'bayi-toplamlar' })
      const kaydet = oge('button', { type: 'button', sinif: 'hdt-btn hdt-btn-solid' }, [oge('span', { metin: taslak ? 'Onayla ve gönder' : 'Değişiklikleri kaydet' })])
      const vazgec = oge('button', { type: 'button', sinif: 'hdt-btn hdt-btn-outline' }, [oge('span', { metin: 'Vazgeç' })])
      vazgec.addEventListener('click', () => detayGoster(s.no))

      function yontem() {
        return yontemler.find((y) => y.kod === secili) || null
      }

      function katsayi() {
        const y = yontem()
        return y ? y.katsayi : s.katsayi
      }

      function fiyatlar(k) {
        const kat = katsayi()
        const bayiFiyat = kat ? Math.round((k.listeFiyat * 100) / kat) : k.listeFiyat
        return { bayiFiyat, birim: Math.floor((bayiFiyat * (10000 - k.oran)) / 10000) }
      }

      function toplamSatiri(etiket, deger, sinif) {
        return oge('div', { sinif: sinif || false }, [oge('span', { metin: etiket }), oge('span', { metin: deger })])
      }

      function hesapla() {
        let liste = 0
        let baz = 0
        let toplam = 0
        let eksik = !kalemler.length
        kalemler.forEach((k) => {
          const f = fiyatlar(k)
          k.birimHucre.textContent = para(f.birim)
          k.birimDar.textContent = 'Birim fiyat: ' + para(f.birim) + (k.oran ? ' (' + yuzde(k.oran) + ' iskontolu)' : '')
          if (!k.adet) {
            k.tutarHucre.textContent = '—'
            eksik = true
            return
          }
          k.tutarHucre.textContent = para(f.birim * k.adet)
          liste += k.listeFiyat * k.adet
          baz += f.bayiFiyat * k.adet
          toplam += f.birim * k.adet
        })
        const y = yontem()
        const kat = katsayi()
        toplamAlani.replaceChildren(
          ...[
            toplamSatiri('Liste toplamı', para(liste)),
            kat ? toplamSatiri((y ? y.ad : s.odemeAdi) + ' (liste ÷ ' + (y ? y.katsayiMetni : s.katsayiMetni) + ')', '-' + para(liste - baz)) : null,
            toplamSatiri('İskonto', '-' + para(baz - toplam)),
            toplamSatiri(kat ? 'Ödeyeceğiniz tutar' : 'Genel toplam', eksik ? '—' : para(toplam), 'bayi-genel')
          ].filter(Boolean)
        )
        kaydet.disabled = eksik
      }

      function ciz() {
        govde.replaceChildren()
        if (!kalemler.length) govde.appendChild(oge('tr', {}, [oge('td', { colspan: '7', sinif: 'bayi-bos-hucre', metin: 'Siparişte ürün kalmadı. Aşağıdan ürün ekleyin.' })]))
        kalemler.forEach((k) => {
          const adet = oge('input', { type: 'number', min: '1', max: '9999', step: '1', inputmode: 'numeric', value: String(k.adet), sinif: 'hdt-input bayi-adet', 'aria-label': k.urunAd + ' adedi' })
          adet.addEventListener('input', () => {
            const deger = Math.floor(Number(adet.value))
            k.adet = deger >= 1 && deger <= 9999 ? deger : 0
            hesapla()
          })
          const cikar = oge('button', { type: 'button', metin: 'Çıkar', 'aria-label': k.urunAd + ' ürününü çıkar' })
          cikar.addEventListener('click', () => {
            kalemler.splice(kalemler.indexOf(k), 1)
            ciz()
          })
          k.birimHucre = oge('td', { sinif: 'bayi-sag bayi-dar-gizle' })
          k.birimDar = oge('span', { sinif: 'bayi-dar-goster' })
          k.tutarHucre = oge('td', { sinif: 'bayi-sag' })
          govde.appendChild(
            oge('tr', {}, [
              oge('td', { sinif: 'bayi-urun' }, [k.urunAd, oge('span', { metin: [k.sku, k.varyantAd].filter(Boolean).join(' · ') }), k.birimDar]),
              oge('td', { sinif: 'bayi-sag' }, [adet]),
              oge('td', { sinif: 'bayi-sag bayi-dar-gizle', metin: para(k.listeFiyat) }),
              oge('td', { sinif: 'bayi-sag bayi-dar-gizle', metin: yuzde(k.oran) }),
              k.birimHucre,
              k.tutarHucre,
              oge('td', { sinif: 'bayi-sag' }, [cikar])
            ])
          )
        })
        hesapla()
      }

      const aramaGirdisi = oge('input', { type: 'search', sinif: 'hdt-input', placeholder: 'Ürün adı ya da kodu yazın (en az 2 harf)', autocomplete: 'off' })
      const sonuclar = oge('div', { sinif: 'bayi-arama-sonuclari', hidden: true })
      let bekleyen = null
      let sira = 0

      function ekle(u) {
        const mevcut = kalemler.find((k) => k.variantId === u.variantId)
        if (mevcut) mevcut.adet = Math.min((mevcut.adet || 0) + 1, 9999)
        else kalemler.push({ variantId: u.variantId, urunAd: u.urunAd, varyantAd: u.varyantAd, sku: u.sku, listeFiyat: u.fiyat, oran: u.oran, adet: 1 })
        ciz()
      }

      function sonuclariGoster(urunler) {
        sonuclar.replaceChildren()
        if (!urunler.length) sonuclar.appendChild(oge('p', { sinif: 'bayi-arama-bos', metin: 'Eklenebilecek ürün bulunamadı.' }))
        urunler.slice(0, 12).forEach((u) => {
          const dugme = oge('button', { type: 'button' }, [
            u.gorsel ? oge('img', { src: u.gorsel + (u.gorsel.includes('?') ? '&' : '?') + 'width=96', alt: '', loading: 'lazy' }) : oge('span', { sinif: 'bayi-arama-gorsel' }),
            oge('span', {}, [oge('b', { metin: u.urunAd }), oge('small', { metin: [u.sku, u.varyantAd, 'Liste ' + para(u.fiyat), u.oran ? yuzde(u.oran) + ' iskonto' : ''].filter(Boolean).join(' · ') })])
          ])
          dugme.addEventListener('click', () => {
            ekle(u)
            sonuclar.hidden = true
            aramaGirdisi.value = ''
            aramaGirdisi.focus()
          })
          sonuclar.appendChild(dugme)
        })
        sonuclar.hidden = false
      }

      aramaGirdisi.addEventListener('input', () => {
        clearTimeout(bekleyen)
        const metin = aramaGirdisi.value.trim()
        if (metin.length < 2) {
          sonuclar.hidden = true
          return
        }
        const benim = ++sira
        bekleyen = setTimeout(async () => {
          try {
            const veri = await api('/urun-ara?q=' + encodeURIComponent(metin), { jetonlu: true })
            if (benim === sira) sonuclariGoster(veri.urunler || [])
          } catch (hata) {
            if (benim !== sira) return
            sonuclar.hidden = true
            hataIsle(hata)
          }
        }, 300)
      })
      aramaGirdisi.addEventListener('keydown', (olay) => {
        if (olay.key === 'Enter') olay.preventDefault()
      })

      const odemeSecimi = yontemler.length
        ? oge('select', { sinif: 'hdt-input' }, [secili ? null : oge('option', { value: '', metin: 'Seçin' }), ...yontemler.map((y) => oge('option', { value: y.kod, selected: y.kod === secili, metin: y.ad + ' — liste fiyatı ÷ ' + y.katsayiMetni }))])
        : null
      if (odemeSecimi) {
        odemeSecimi.addEventListener('change', () => {
          secili = odemeSecimi.value
          hesapla()
        })
      }
      const notAlani = oge('textarea', { sinif: 'hdt-textarea', rows: '2', maxlength: '1000', placeholder: 'Siparişle ilgili notunuz (isteğe bağlı)' })
      notAlani.value = s.not || ''

      kaydet.addEventListener('click', () => {
        if (yontemler.length && !secili) {
          mesajGoster(bolum, 'Lütfen ödeme yöntemini seçin.')
          return
        }
        siparisGonder(s, { kalemler: kalemGovdesi(kalemler), odemeYontemi: secili, not: notAlani.value }, kaydet)
      })

      const geri = oge('button', { type: 'button', sinif: 'bayi-geri', metin: '‹ Siparişe dön' })
      geri.addEventListener('click', () => detayGoster(s.no))
      const basliklar = ['Ürün', 'Adet', 'Liste fiyatı', 'İskonto', 'Birim fiyat', 'Tutar', '']
      doldur([
        geri,
        oge('div', { sinif: 'bayi-bolum-basligi' }, [oge('div', { sinif: 'bayi-baslik-satiri' }, [oge('h2', { sinif: 'hdt-heading hdt-h5', metin: s.no + ' — değiştir' }), rozet(s)])]),
        oge('p', { sinif: 'bayi-not bayi-not--ust', metin: 'Adetleri değiştirebilir, ürün ekleyip çıkarabilirsiniz. İskonto oranları hesabınıza tanımlı oranlardır. ' + (taslak ? 'Onayladığınızda siparişiniz ekibimize iletilir.' : 'Kaydettiğinizde güncel siparişiniz ekibimize iletilir.') }),
        odemeSecimi ? oge('div', { sinif: 'bayi-duzenle-ust' }, [alan('Ödeme yöntemi', odemeSecimi)]) : null,
        oge('div', { sinif: 'bayi-tablo-sarici' }, [
          oge('table', { sinif: 'bayi-tablo bayi-tablo--duzenle' }, [oge('thead', {}, [oge('tr', {}, basliklar.map((b, i) => oge('th', { sinif: [i ? 'bayi-sag' : '', i >= 2 && i <= 4 ? 'bayi-dar-gizle' : ''].join(' ').trim(), metin: b })))]), govde])
        ]),
        toplamAlani,
        oge('div', { sinif: 'bayi-urun-ekle' }, [alan('Ürün ekle', aramaGirdisi), sonuclar]),
        oge('div', { sinif: 'bayi-duzenle-ust' }, [alan('Notunuz', notAlani)]),
        oge('div', { sinif: 'bayi-dugmeler bayi-duzenle-alt' }, [kaydet, vazgec])
      ])
      ciz()
    }

    async function detayGoster(no) {
      temizle()
      yukleniyor()
      let veri
      try {
        veri = await api('/siparisler/' + encodeURIComponent(no), { jetonlu: true })
      } catch (hata) {
        await hataIsle(hata)
        return listeGoster()
      }
      const s = veri.siparis
      const taslak = s.durum === 'bayi_onayi'
      const geri = oge('button', { type: 'button', sinif: 'bayi-geri', metin: '‹ Tüm siparişler' })
      geri.addEventListener('click', listeGoster)
      const pdf = oge('button', { type: 'button', sinif: taslak ? 'hdt-btn hdt-btn-outline' : 'hdt-btn hdt-btn-solid' }, [oge('span', { metin: 'Proforma PDF indir' })])
      pdf.addEventListener('click', () => pdfIndir(s.no, pdf))
      const islemler = []
      if (taslak) {
        const onayla = oge('button', { type: 'button', sinif: 'hdt-btn hdt-btn-solid' }, [oge('span', { metin: 'Siparişi onayla' })])
        onayla.addEventListener('click', () => {
          if ((s.odemeYontemleri || []).length && !s.odemeYontemi) {
            duzenlemeGoster(s)
            mesajGoster(bolum, 'Onaylamadan önce ödeme yöntemini seçin.')
            return
          }
          if (!window.confirm(s.no + ' numaralı sipariş bu haliyle onaylansın mı?')) return
          siparisGonder(s, { kalemler: kalemGovdesi(s.kalemler), odemeYontemi: s.odemeYontemi }, onayla)
        })
        islemler.push(onayla)
      }
      if (s.duzenlenebilir) {
        const degistir = oge('button', { type: 'button', sinif: 'hdt-btn hdt-btn-outline' }, [oge('span', { metin: taslak ? 'Değiştir' : 'Siparişi değiştir' })])
        degistir.addEventListener('click', () => duzenlemeGoster(s))
        islemler.push(degistir)
      }
      islemler.push(pdf)
      const baslik = oge('div', { sinif: 'bayi-bolum-basligi' }, [
        oge('div', {}, [
          oge('div', { sinif: 'bayi-baslik-satiri' }, [oge('h2', { sinif: 'hdt-heading hdt-h5', metin: s.no }), rozet(s)]),
          oge('p', { sinif: 'hdt-s-text', metin: tarihSaatBicimi.format(new Date(s.tarih)) + (s.revizyon ? ' · ' + s.revizyon + '. revizyon' : '') })
        ]),
        oge('div', { sinif: 'bayi-dugmeler' }, islemler)
      ])
      const onayBandi = taslak
        ? oge('div', { sinif: 'bayi-uyari bayi-uyari--onay' }, [
            oge('b', { metin: 'Bu sipariş onayınızı bekliyor.' }),
            oge('span', { metin: (s.hazirlayanAd ? s.hazirlayanAd : 'Ekibimiz') + ' tarafından sizin adınıza hazırlandı. Olduğu gibi onaylayabilir ya da adetleri değiştirip ürün ekleyip çıkararak onaylayabilirsiniz.' }),
            s.hazirlayanNotu ? oge('span', { metin: 'Not: ' + s.hazirlayanNotu }) : null
          ])
        : null
      const katsayili = Boolean(s.katsayi)
      const satirlar = s.kalemler.map((k) =>
        oge('tr', {}, [
          oge('td', { sinif: 'bayi-urun' }, [k.urunAd, oge('span', { metin: [k.sku, k.varyantAd].filter(Boolean).join(' · ') })]),
          oge('td', { sinif: 'bayi-sag', metin: String(k.adet) }),
          oge('td', { sinif: 'bayi-sag', metin: para(k.listeFiyat) }),
          oge('td', { sinif: 'bayi-sag', metin: yuzde(k.iskontoOrani) }),
          oge('td', { sinif: 'bayi-sag', metin: para(k.birimFiyat) }),
          oge('td', { sinif: 'bayi-sag', metin: para(k.tutar) })
        ])
      )
      const toplamlar = oge('div', { sinif: 'bayi-toplamlar' }, [
        oge('div', {}, [oge('span', { metin: 'Liste toplamı' }), oge('span', { metin: para(s.listeToplam) })]),
        katsayili ? oge('div', {}, [oge('span', { metin: s.odemeAdi + ' (liste ÷ ' + s.katsayiMetni + ')' }), oge('span', { metin: '-' + para(s.odemeFarki) })]) : null,
        oge('div', {}, [oge('span', { metin: 'İskonto' }), oge('span', { metin: '-' + para(s.iskontoToplam) })]),
        oge('div', { sinif: 'bayi-genel' }, [oge('span', { metin: katsayili ? 'Ödeyeceğiniz tutar' : 'Genel toplam' }), oge('span', { metin: para(s.toplam) })])
      ])
      doldur([
        geri,
        baslik,
        onayBandi,
        taslak ? null : adimCizelgesi(s),
        s.duzenlenebilir && !taslak ? oge('p', { sinif: 'bayi-not', metin: 'Siparişiniz onaylanana kadar değişiklik yapabilirsiniz.' }) : null,
        s.revizyon && !taslak ? oge('p', { sinif: 'bayi-not', metin: 'Bu sipariş oluşturulduktan sonra güncellendi; aşağıda güncel hali yer alıyor.' }) : null,
        katsayili ? oge('p', { sinif: 'bayi-not', metin: 'Ödeme yöntemi: ' + s.odemeAdi + '. Birim fiyatlar liste fiyatının ' + s.katsayiMetni + ' katsayısına bölünmesiyle hesaplandı.' }) : null,
        bilgiKutulari(s),
        tablo([{ ad: 'Ürün' }, { ad: 'Adet', sag: true }, { ad: 'Liste fiyatı', sag: true }, { ad: 'İskonto', sag: true }, { ad: 'Birim fiyat', sag: true }, { ad: 'Tutar', sag: true }], satirlar),
        toplamlar,
        s.not ? oge('p', { sinif: 'bayi-not', metin: 'Notunuz: ' + s.not }) : null
      ])
    }

    async function listeGoster() {
      temizle()
      let veri
      try {
        veri = await api('/siparisler', { jetonlu: true })
      } catch (hata) {
        doldur([])
        return hataIsle(hata)
      }
      const baslik = oge('div', { sinif: 'bayi-bolum-basligi' }, [oge('h2', { sinif: 'hdt-heading hdt-h5', metin: 'Siparişlerim' })])
      if (!veri.siparisler.length) {
        doldur([oranlar(), baslik, oge('p', { sinif: 'bayi-bos hdt-s-text', metin: 'Henüz siparişiniz yok. Ürünleri sepete ekleyip sepetinizden sipariş oluşturabilirsiniz.' })])
        return
      }
      const satirlar = veri.siparisler.map((s) => {
        const ac = oge('button', { type: 'button', metin: s.no })
        ac.addEventListener('click', () => detayGoster(s.no))
        return oge('tr', {}, [
          oge('td', {}, [ac]),
          oge('td', { metin: tarihSaatBicimi.format(new Date(s.tarih)) }),
          oge('td', {}, [rozet(s)]),
          oge('td', { metin: s.odemeAdi || '—' }),
          oge('td', { sinif: 'bayi-sag', metin: String(s.adetToplam) }),
          oge('td', { sinif: 'bayi-sag', metin: para(s.toplam) })
        ])
      })
      const bekleyen = veri.siparisler.filter((s) => s.durum === 'bayi_onayi').length
      const bekleyenBandi = bekleyen
        ? oge('div', { sinif: 'bayi-uyari bayi-uyari--onay' }, [oge('b', { metin: bekleyen + ' sipariş onayınızı bekliyor.' }), oge('span', { metin: 'İncelemek ve onaylamak için sipariş numarasına tıklayın.' })])
        : null
      doldur([bekleyenBandi, oranlar(), baslik, tablo([{ ad: 'Proforma' }, { ad: 'Tarih' }, { ad: 'Durum' }, { ad: 'Ödeme' }, { ad: 'Adet', sag: true }, { ad: 'Toplam', sag: true }], satirlar)])
    }

    function gonderDugmesi(metin) {
      return oge('button', { type: 'submit', sinif: 'hdt-btn hdt-btn-solid' }, [oge('span', { metin })])
    }

    async function formGonder(form, is) {
      temizle()
      mesgul(form, true)
      try {
        await is()
      } catch (hata) {
        await hataIsle(hata)
      } finally {
        mesgul(form, false)
      }
    }

    async function profilGoster() {
      temizle()
      yukleniyor()
      try {
        await profilYukle()
      } catch (hata) {
        doldur([])
        return hataIsle(hata)
      }
      const form = oge('form', { sinif: 'bayi-form bayi-form--iki', novalidate: true }, [
        alan('Firma', girdi('firma', bilgi.firma, { disabled: true })),
        alan('E-posta', girdi('email', bilgi.email, { disabled: true })),
        alan('Vergi dairesi', girdi('vergiDairesi', bilgi.vergiDairesi, { disabled: true })),
        alan('Vergi / T.C. kimlik no', girdi('vergiNo', bilgi.vergiNo, { disabled: true }), 'Firma, e-posta ve vergi bilgilerini değiştirmek için temsilcinize başvurun.'),
        alan('Yetkili adı soyadı', girdi('yetkili', bilgi.yetkili, { maxlength: 200, required: true })),
        alan('Telefon', girdi('telefon', bilgi.telefon, { type: 'tel', maxlength: 40 }), 'Proforma ve durum bildirimleri WhatsApp ile bu numaraya gelir.'),
        alan('Adres', girdi('adres', bilgi.adres, { maxlength: 500, 'data-tam': '1' })),
        alan('Şehir', girdi('il', bilgi.il, { maxlength: 100 })),
        alan('Ülke', girdi('ulke', bilgi.ulke, { maxlength: 100 })),
        oge('div', { sinif: 'bayi-alan--tam' }, [gonderDugmesi('Bilgilerimi kaydet')])
      ])
      form.addEventListener('submit', (olay) => {
        olay.preventDefault()
        formGonder(form, async () => {
          const e = form.elements
          const veri = await api('/profil', {
            yontem: 'POST',
            jetonlu: true,
            govde: { yetkili: e.yetkili.value, telefon: e.telefon.value, adres: e.adres.value, il: e.il.value, ulke: e.ulke.value }
          })
          bilgi = veri.bayi
          bilgiYaz(bilgi)
          kunyeYaz()
          basari('Bilgileriniz kaydedildi.')
        })
      })
      doldur([oge('div', { sinif: 'bayi-bolum-basligi' }, [oge('h2', { sinif: 'hdt-heading hdt-h5', metin: 'Profilim' })]), oranlar(), form])
    }

    function adresFormu(mevcut) {
      const a = mevcut || {}
      const varsayilan = oge('input', { type: 'checkbox', name: 'varsayilan', checked: Boolean(a.varsayilan) })
      const vazgec = oge('button', { type: 'button', sinif: 'hdt-btn hdt-btn-outline' }, [oge('span', { metin: 'Vazgeç' })])
      vazgec.addEventListener('click', adresleriGoster)
      const form = oge('form', { sinif: 'bayi-form bayi-form--iki', novalidate: true }, [
        alan('Adres başlığı *', girdi('baslik', a.baslik, { maxlength: 60, required: true, placeholder: 'Örn. Mağaza, Depo' })),
        alan('Teslim alacak kişi', girdi('alici', a.alici, { maxlength: 120 })),
        alan('Telefon', girdi('telefon', a.telefon, { type: 'tel', maxlength: 40 })),
        alan('İlçe', girdi('ilce', a.ilce, { maxlength: 100 })),
        alan('Adres *', girdi('adres', a.adres, { maxlength: 500, required: true, 'data-tam': '1' })),
        alan('Şehir', girdi('il', a.il, { maxlength: 100 })),
        alan('Ülke', girdi('ulke', a.ulke || 'Türkiye', { maxlength: 100 })),
        oge('label', { sinif: 'bayi-onay bayi-alan--tam' }, [varsayilan, oge('span', { metin: 'Proformalarda varsayılan teslimat adresim olsun' })]),
        oge('div', { sinif: 'bayi-dugmeler bayi-alan--tam' }, [gonderDugmesi(mevcut ? 'Adresi kaydet' : 'Adresi ekle'), vazgec])
      ])
      form.addEventListener('submit', (olay) => {
        olay.preventDefault()
        formGonder(form, async () => {
          const e = form.elements
          const govde = { varsayilan: e.varsayilan.checked }
          ;['baslik', 'alici', 'telefon', 'ilce', 'adres', 'il', 'ulke'].forEach((ad) => {
            govde[ad] = e[ad].value.trim()
          })
          if (!govde.baslik || !govde.adres) throw new Error('Adres başlığı ve adres zorunludur.')
          const veri = await api(mevcut ? '/adresler/' + mevcut.id : '/adresler', { yontem: 'POST', jetonlu: true, govde })
          bilgi.adresler = veri.adresler
          bilgiYaz(bilgi)
          adresListesi()
          basari(mevcut ? 'Adres güncellendi.' : 'Adres eklendi.')
        })
      })
      doldur([oge('div', { sinif: 'bayi-bolum-basligi' }, [oge('h2', { sinif: 'hdt-heading hdt-h5', metin: mevcut ? 'Adresi düzenle' : 'Yeni adres' })]), form])
    }

    function adresListesi() {
      const ekle = oge('button', { type: 'button', sinif: 'hdt-btn hdt-btn-solid' }, [oge('span', { metin: 'Yeni adres ekle' })])
      ekle.addEventListener('click', () => {
        temizle()
        adresFormu(null)
      })
      const baslik = oge('div', { sinif: 'bayi-bolum-basligi' }, [oge('h2', { sinif: 'hdt-heading hdt-h5', metin: 'Adreslerim' }), ekle])
      const adresler = bilgi.adresler || []
      if (!adresler.length) {
        doldur([baslik, oge('p', { sinif: 'bayi-bos hdt-s-text', metin: 'Kayıtlı teslimat adresiniz yok. Adres eklemezseniz proformalarda firma adresiniz kullanılır.' })])
        return
      }
      const kartlar = adresler.map((a) => {
        const duzenle = oge('button', { type: 'button', sinif: 'bayi-baglanti', metin: 'Düzenle' })
        duzenle.addEventListener('click', () => {
          temizle()
          adresFormu(a)
        })
        const sil = oge('button', { type: 'button', sinif: 'bayi-baglanti', metin: 'Sil' })
        sil.addEventListener('click', async () => {
          if (!window.confirm('"' + a.baslik + '" adresi silinsin mi?')) return
          temizle()
          try {
            const veri = await api('/adresler/' + a.id + '/sil', { yontem: 'POST', jetonlu: true })
            bilgi.adresler = veri.adresler
            bilgiYaz(bilgi)
            adresListesi()
            basari('Adres silindi.')
          } catch (hata) {
            hataIsle(hata)
          }
        })
        const varsayilanYap = a.varsayilan ? null : oge('button', { type: 'button', sinif: 'bayi-baglanti', metin: 'Varsayılan yap' })
        if (varsayilanYap) {
          varsayilanYap.addEventListener('click', async () => {
            temizle()
            try {
              const veri = await api('/adresler/' + a.id, { yontem: 'POST', jetonlu: true, govde: Object.assign({}, a, { varsayilan: true }) })
              bilgi.adresler = veri.adresler
              bilgiYaz(bilgi)
              adresListesi()
              basari('Varsayılan adres değiştirildi.')
            } catch (hata) {
              hataIsle(hata)
            }
          })
        }
        return oge('div', { sinif: 'bayi-adres' }, [
          oge('b', {}, [a.baslik, a.varsayilan ? oge('span', { sinif: 'bayi-rozet', metin: 'Varsayılan' }) : null]),
          oge('span', { metin: adresMetni(a) }),
          a.telefon ? oge('span', { metin: a.telefon }) : null,
          oge('div', { sinif: 'bayi-adres__islem' }, [duzenle, varsayilanYap, sil])
        ])
      })
      doldur([baslik, oge('div', { sinif: 'bayi-adresler' }, kartlar)])
    }

    async function adresleriGoster() {
      temizle()
      yukleniyor()
      try {
        await profilYukle()
      } catch (hata) {
        doldur([])
        return hataIsle(hata)
      }
      adresListesi()
    }

    function sifreGoster() {
      temizle()
      const form = oge('form', { sinif: 'bayi-form bayi-form--dar', novalidate: true }, [
        alan('Mevcut şifre', girdi('mevcut', '', { type: 'password', autocomplete: 'current-password', required: true })),
        alan('Yeni şifre', girdi('yeni', '', { type: 'password', autocomplete: 'new-password', minlength: 6, maxlength: 100, required: true }), 'En az 6 karakter.'),
        alan('Yeni şifre (tekrar)', girdi('tekrar', '', { type: 'password', autocomplete: 'new-password', minlength: 6, maxlength: 100, required: true })),
        oge('div', {}, [gonderDugmesi('Şifremi değiştir')])
      ])
      form.addEventListener('submit', (olay) => {
        olay.preventDefault()
        formGonder(form, async () => {
          const e = form.elements
          if (e.yeni.value.length < 6) throw new Error('Yeni şifre en az 6 karakter olmalıdır.')
          if (e.yeni.value !== e.tekrar.value) throw new Error('Yeni şifreler birbiriyle aynı değil.')
          const veri = await api('/sifre-degistir', { yontem: 'POST', jetonlu: true, govde: { mevcut: e.mevcut.value, yeni: e.yeni.value } })
          depoYaz(localStorage, JETON, veri.jeton)
          form.reset()
          basari('Şifreniz değiştirildi. Diğer cihazlardaki oturumlarınız kapatıldı.')
        })
      })
      doldur([oge('div', { sinif: 'bayi-bolum-basligi' }, [oge('h2', { sinif: 'hdt-heading hdt-h5', metin: 'Şifre değiştir' })]), form])
    }

    const gosterenler = { siparisler: listeGoster, profil: profilGoster, adresler: adresleriGoster, sifre: sifreGoster }

    function sekmeAc(ad) {
      sekmeler.forEach((s) => {
        const secili = s.dataset.bayiSekme === ad
        s.classList.toggle('secili', secili)
        s.setAttribute('aria-selected', String(secili))
      })
      bolum.querySelector('[data-bayi-yeni]').hidden = true
      gosterenler[ad]()
    }

    sekmeler.forEach((s) => s.addEventListener('click', () => sekmeAc(s.dataset.bayiSekme)))

    if (!jeton()) {
      window.location.href = girisAdresi()
      return
    }
    kunyeYaz()
    profilYukle().catch(() => null)
    const parametreler = new URLSearchParams(window.location.search)
    const acilacak = parametreler.get('siparis')
    if (acilacak) {
      if (parametreler.get('yeni') === '1') {
        const kutu = bolum.querySelector('[data-bayi-yeni]')
        kutu.textContent = acilacak + ' numaralı siparişiniz oluşturuldu ve ekibimize iletildi. Onaylandığında durumunu buradan izleyebilirsiniz.'
        kutu.hidden = false
      }
      window.history.replaceState(null, '', window.location.pathname)
      detayGoster(acilacak)
    } else {
      listeGoster()
    }
  }

  const ROZET_SINIFLARI = {
    'İptal edildi': 'iptal',
    'İade edildi': 'iptal',
    'Teslim edildi': 'tamamlandi',
    'Teslim alındı': 'tamamlandi',
    'Kargoya verildi': 'sevk_edildi',
    'Kısmen kargoya verildi': 'sevk_edildi',
    Yolda: 'sevk_edildi',
    'Dağıtımda': 'sevk_edildi',
    'Hazırlanıyor': 'hazirlaniyor'
  }

  function musteriAdresMetni(a) {
    return [[a.ad, a.soyad].filter(Boolean).join(' '), a.adres, a.ilce, [a.postaKodu, a.il].filter(Boolean).join(' '), a.ulke].filter(Boolean).join(', ')
  }

  function musteriHesabi(bolum) {
    const icerik = bolum.querySelector('[data-bayi-icerik]')
    const sekmeler = bolum.querySelectorAll('[data-bayi-sekme]')
    let bilgi = bilgiAl() || {}

    function temizle() {
      mesajGoster(bolum, '')
      mesajGoster(bolum, '', '[data-bayi-bilgi]')
    }

    function basari(metin) {
      mesajGoster(bolum, metin, '[data-bayi-bilgi]')
    }

    function bilgiKaydet(hesap) {
      bilgi = hesap
      bilgiYaz(bilgi)
      kunyeYaz()
    }

    function kunyeYaz() {
      bolum.querySelector('[data-bayi-firma]').textContent = bilgi.ad ? 'Merhaba, ' + bilgi.ad : 'Hesabım'
      bolum.querySelector('[data-bayi-kunye]').textContent = bilgi.email || ''
      bolum.querySelector('[data-bayi-temsilci]').hidden = true
    }

    async function hataIsle(hata) {
      if (hata.durum === 401) {
        await oturumuKapat(ayar.sayfalar.giris)
        return
      }
      mesajGoster(bolum, hata.message)
    }

    function dogrulamaUyarisi() {
      if (bilgi.epostaDogrulandi) return null
      const gonder = oge('button', { type: 'button', sinif: 'bayi-baglanti', metin: 'Bağlantıyı yeniden gönder' })
      gonder.addEventListener('click', async () => {
        temizle()
        gonder.disabled = true
        try {
          const veri = await api('/hesap/dogrulama-gonder', { yontem: 'POST', jetonlu: true, govde: {} })
          if (veri.dogrulandi) {
            bilgiKaydet(Object.assign({}, bilgi, { epostaDogrulandi: true }))
            sekmeAc('siparisler')
            return
          }
          basari('Doğrulama bağlantısı ' + bilgi.email + ' adresine gönderildi.')
        } catch (hata) {
          await hataIsle(hata)
        } finally {
          gonder.disabled = false
        }
      })
      return oge('div', { sinif: 'bayi-uyari bayi-uyari--bilgi', role: 'status' }, [
        oge('span', { metin: 'E-posta adresinizi henüz doğrulamadınız. Gelen kutunuzdaki bağlantıya tıklayın; gelmediyse gereksiz klasörüne bakın.' }),
        gonder
      ])
    }

    function doldur(dugumler) {
      icerik.replaceChildren(...[dogrulamaUyarisi()].concat(dugumler).filter(Boolean))
    }

    function yukleniyor() {
      doldur([oge('p', { sinif: 'bayi-yukleniyor hdt-s-text', metin: 'Yükleniyor…' })])
    }

    function bolumBasligi(metin, ek) {
      return oge('div', { sinif: 'bayi-bolum-basligi' }, [oge('h2', { sinif: 'hdt-heading hdt-h5', metin }), ek || null])
    }

    function gonderDugmesi(metin) {
      return oge('button', { type: 'submit', sinif: 'hdt-btn hdt-btn-solid' }, [oge('span', { metin })])
    }

    async function formGonder(form, is) {
      temizle()
      mesgul(form, true)
      try {
        await is()
      } catch (hata) {
        await hataIsle(hata)
      } finally {
        mesgul(form, false)
      }
    }

    function siparisRozeti(s) {
      return oge('span', { sinif: 'bayi-rozet bayi-rozet--' + (ROZET_SINIFLARI[s.durum] || 'onay_bekliyor'), metin: s.durum })
    }

    function siparisDetayi(s, liste) {
      temizle()
      const geri = oge('button', { type: 'button', sinif: 'bayi-geri', metin: '‹ Tüm siparişler' })
      geri.addEventListener('click', () => siparisListesi(liste))
      const durumSayfasi = /^https:\/\//i.test(s.durumAdresi)
        ? oge('a', { sinif: 'hdt-btn hdt-btn-solid', href: s.durumAdresi, target: '_blank', rel: 'noopener' }, [oge('span', { metin: 'Sipariş durumunu aç' })])
        : null
      const baslik = oge('div', { sinif: 'bayi-bolum-basligi' }, [
        oge('div', {}, [
          oge('div', { sinif: 'bayi-baslik-satiri' }, [oge('h2', { sinif: 'hdt-heading hdt-h5', metin: 'Sipariş ' + s.no }), siparisRozeti(s)]),
          oge('p', { sinif: 'hdt-s-text', metin: [tarihSaatBicimi.format(new Date(s.tarih)), s.odeme].filter(Boolean).join(' · ') })
        ]),
        durumSayfasi
      ])
      const kalemler = oge(
        'ul',
        { sinif: 'bayi-kalemler' },
        s.kalemler.map((k) =>
          oge('li', { sinif: 'bayi-kalem' }, [
            /^https:\/\//i.test(k.gorsel) ? oge('img', { src: k.gorsel, alt: '', loading: 'lazy', width: '56', height: '56' }) : oge('span', { sinif: 'bayi-kalem__bos' }),
            oge('div', {}, [oge('b', { metin: k.ad }), oge('span', { metin: [k.secenek, k.adet + ' adet'].filter(Boolean).join(' · ') })]),
            oge('span', { metin: para(k.tutar) })
          ])
        )
      )
      const kutular = []
      if (s.takip.length) {
        kutular.push(
          oge(
            'div',
            { sinif: 'bayi-kutu-bilgi' },
            [oge('b', { metin: 'Kargo takibi' })].concat(
              s.takip.map((t) =>
                /^https?:\/\//i.test(t.adres)
                  ? oge('a', { sinif: 'hdt-link-underline', href: t.adres, target: '_blank', rel: 'noopener', metin: [t.firma, t.no].filter(Boolean).join(' · ') || 'Kargoyu takip et' })
                  : oge('span', { metin: [t.firma, t.no].filter(Boolean).join(' · ') })
              )
            )
          )
        )
      }
      if (s.teslimat) kutular.push(oge('div', { sinif: 'bayi-kutu-bilgi' }, [oge('b', { metin: 'Teslimat adresi' }), oge('span', { metin: s.teslimat })]))
      doldur([
        geri,
        baslik,
        kutular.length ? oge('div', { sinif: 'bayi-kutular' }, kutular) : null,
        kalemler,
        oge('div', { sinif: 'bayi-toplamlar' }, [oge('div', { sinif: 'bayi-genel' }, [oge('span', { metin: 'Toplam' }), oge('span', { metin: para(s.toplam) })])])
      ])
    }

    function siparisListesi(liste) {
      const baslik = bolumBasligi('Siparişlerim')
      if (!liste.length) {
        doldur([
          baslik,
          oge('p', { sinif: 'bayi-bos hdt-s-text' }, ['Henüz siparişiniz yok. ', oge('a', { sinif: 'hdt-link-underline', href: kok, metin: 'Alışverişe başlayın' })])
        ])
        return
      }
      const satirlar = liste.map((s) => {
        const ac = oge('button', { type: 'button', metin: s.no })
        ac.addEventListener('click', () => siparisDetayi(s, liste))
        return oge('tr', {}, [
          oge('td', {}, [ac]),
          oge('td', { metin: tarihBicimi.format(new Date(s.tarih)) }),
          oge('td', {}, [siparisRozeti(s)]),
          oge('td', { sinif: 'bayi-sag', metin: String(s.adet) }),
          oge('td', { sinif: 'bayi-sag', metin: para(s.toplam) })
        ])
      })
      doldur([baslik, tablo([{ ad: 'Sipariş' }, { ad: 'Tarih' }, { ad: 'Durum' }, { ad: 'Adet', sag: true }, { ad: 'Toplam', sag: true }], satirlar)])
    }

    async function siparisleriGoster() {
      temizle()
      yukleniyor()
      let veri
      try {
        veri = await api('/hesap/siparisler', { jetonlu: true })
      } catch (hata) {
        doldur([bolumBasligi('Siparişlerim')])
        return hataIsle(hata)
      }
      if (veri.dogrulamaGerekli) {
        doldur([bolumBasligi('Siparişlerim'), oge('p', { sinif: 'bayi-bos hdt-s-text', metin: 'Siparişlerinizi görebilmek için önce e-posta adresinizi doğrulayın.' })])
        return
      }
      siparisListesi(veri.siparisler)
    }

    function profilGoster() {
      temizle()
      const izin = oge('input', { type: 'checkbox', name: 'pazarlamaIzni', checked: Boolean(bilgi.pazarlamaIzni) })
      const form = oge('form', { sinif: 'bayi-form bayi-form--iki', novalidate: true }, [
        alan('Ad *', girdi('ad', bilgi.ad, { maxlength: 60, autocomplete: 'given-name', required: true })),
        alan('Soyad *', girdi('soyad', bilgi.soyad, { maxlength: 60, autocomplete: 'family-name', required: true })),
        alan('E-posta', girdi('email', bilgi.email, { disabled: true }), 'E-posta adresinizi değiştirmek için bizimle iletişime geçin.'),
        alan('Telefon', girdi('telefon', bilgi.telefon, { type: 'tel', maxlength: 40, autocomplete: 'tel' })),
        oge('label', { sinif: 'bayi-onay bayi-alan--tam' }, [izin, oge('span', { metin: 'Kampanya ve yeni ürünlerden e-posta ile haberdar olmak istiyorum.' })]),
        oge('div', { sinif: 'bayi-alan--tam' }, [gonderDugmesi('Bilgilerimi kaydet')])
      ])
      form.addEventListener('submit', (olay) => {
        olay.preventDefault()
        formGonder(form, async () => {
          const e = form.elements
          if (!e.ad.value.trim() || !e.soyad.value.trim()) throw new Error('Adınızı ve soyadınızı yazın.')
          const veri = await api('/hesap/profil', {
            yontem: 'POST',
            jetonlu: true,
            govde: { ad: e.ad.value, soyad: e.soyad.value, telefon: e.telefon.value, pazarlamaIzni: e.pazarlamaIzni.checked }
          })
          bilgiKaydet(veri.hesap)
          basari('Bilgileriniz kaydedildi.')
        })
      })
      const silSifre = girdi('sifre', '', { type: 'password', autocomplete: 'current-password', required: true })
      const silFormu = oge('form', { sinif: 'bayi-form bayi-form--dar', novalidate: true }, [
        alan('Onaylamak için şifreniz', silSifre),
        oge('div', {}, [oge('button', { type: 'submit', sinif: 'hdt-btn hdt-btn-outline' }, [oge('span', { metin: 'Üyeliğimi sil' })])])
      ])
      silFormu.addEventListener('submit', (olay) => {
        olay.preventDefault()
        formGonder(silFormu, async () => {
          if (!silSifre.value) throw new Error('Şifrenizi yazın.')
          if (!window.confirm('Üyeliğiniz ve kayıtlı adresleriniz kalıcı olarak silinsin mi?')) return
          await api('/hesap/sil', { yontem: 'POST', jetonlu: true, govde: { sifre: silSifre.value } })
          await oturumuKapat(kok)
        })
      })
      doldur([
        bolumBasligi('Profilim'),
        form,
        oge('div', { sinif: 'bayi-tehlike' }, [
          oge('h3', { metin: 'Üyeliği sil' }),
          oge('p', { metin: 'Üyeliğiniz ve kayıtlı adresleriniz silinir. Verdiğiniz siparişlerin kayıtları yasal saklama süresi boyunca tutulur.' }),
          silFormu
        ])
      ])
    }

    function adresFormu(mevcut) {
      const a = mevcut || {}
      const varsayilan = oge('input', { type: 'checkbox', name: 'varsayilan', checked: Boolean(a.varsayilan) })
      const vazgec = oge('button', { type: 'button', sinif: 'hdt-btn hdt-btn-outline' }, [oge('span', { metin: 'Vazgeç' })])
      vazgec.addEventListener('click', () => {
        temizle()
        adresListesi()
      })
      const form = oge('form', { sinif: 'bayi-form bayi-form--iki', novalidate: true }, [
        alan('Adres başlığı *', girdi('baslik', a.baslik, { maxlength: 60, required: true, placeholder: 'Örn. Ev, İş', 'data-tam': '1' })),
        alan('Ad', girdi('ad', a.ad || (mevcut ? '' : bilgi.ad), { maxlength: 60, autocomplete: 'given-name' })),
        alan('Soyad', girdi('soyad', a.soyad || (mevcut ? '' : bilgi.soyad), { maxlength: 60, autocomplete: 'family-name' })),
        alan('Adres *', girdi('adres', a.adres, { maxlength: 500, required: true, autocomplete: 'street-address', 'data-tam': '1' })),
        alan('İlçe', girdi('ilce', a.ilce, { maxlength: 100 })),
        alan('Şehir *', girdi('il', a.il, { maxlength: 100, required: true })),
        alan('Posta kodu', girdi('postaKodu', a.postaKodu, { maxlength: 12, autocomplete: 'postal-code', inputmode: 'numeric' })),
        alan('Ülke', girdi('ulke', a.ulke || 'Türkiye', { maxlength: 100 })),
        alan('Telefon', girdi('telefon', a.telefon || (mevcut ? '' : bilgi.telefon), { type: 'tel', maxlength: 40, autocomplete: 'tel', 'data-tam': '1' })),
        oge('label', { sinif: 'bayi-onay bayi-alan--tam' }, [varsayilan, oge('span', { metin: 'Varsayılan teslimat adresim olsun; ödemede bu adres hazır gelsin' })]),
        oge('div', { sinif: 'bayi-dugmeler bayi-alan--tam' }, [gonderDugmesi(mevcut ? 'Adresi kaydet' : 'Adresi ekle'), vazgec])
      ])
      form.addEventListener('submit', (olay) => {
        olay.preventDefault()
        formGonder(form, async () => {
          const e = form.elements
          const govde = { varsayilan: e.varsayilan.checked }
          ;['baslik', 'ad', 'soyad', 'adres', 'ilce', 'il', 'postaKodu', 'ulke', 'telefon'].forEach((ad) => {
            govde[ad] = e[ad].value.trim()
          })
          if (!govde.baslik || !govde.adres || !govde.il) throw new Error('Adres başlığı, adres ve şehir zorunludur.')
          const veri = await api(mevcut ? '/hesap/adresler/' + mevcut.id : '/hesap/adresler', { yontem: 'POST', jetonlu: true, govde })
          bilgiKaydet(Object.assign({}, bilgi, { adresler: veri.adresler }))
          adresListesi()
          basari(mevcut ? 'Adres güncellendi.' : 'Adres eklendi.')
        })
      })
      doldur([bolumBasligi(mevcut ? 'Adresi düzenle' : 'Yeni adres'), form])
    }

    function adresListesi() {
      const ekle = oge('button', { type: 'button', sinif: 'hdt-btn hdt-btn-solid' }, [oge('span', { metin: 'Yeni adres ekle' })])
      ekle.addEventListener('click', () => {
        temizle()
        adresFormu(null)
      })
      const baslik = bolumBasligi('Adreslerim', ekle)
      const adresler = bilgi.adresler || []
      if (!adresler.length) {
        doldur([baslik, oge('p', { sinif: 'bayi-bos hdt-s-text', metin: 'Kayıtlı adresiniz yok. Adres eklerseniz ödemede yeniden yazmanız gerekmez.' })])
        return
      }
      const islem = async (is, mesaj) => {
        temizle()
        try {
          const veri = await is()
          bilgiKaydet(Object.assign({}, bilgi, { adresler: veri.adresler }))
          adresListesi()
          basari(mesaj)
        } catch (hata) {
          await hataIsle(hata)
        }
      }
      const kartlar = adresler.map((a) => {
        const duzenle = oge('button', { type: 'button', sinif: 'bayi-baglanti', metin: 'Düzenle' })
        duzenle.addEventListener('click', () => {
          temizle()
          adresFormu(a)
        })
        const sil = oge('button', { type: 'button', sinif: 'bayi-baglanti', metin: 'Sil' })
        sil.addEventListener('click', () => {
          if (!window.confirm('"' + a.baslik + '" adresi silinsin mi?')) return
          islem(() => api('/hesap/adresler/' + a.id + '/sil', { yontem: 'POST', jetonlu: true, govde: {} }), 'Adres silindi.')
        })
        const varsayilanYap = a.varsayilan ? null : oge('button', { type: 'button', sinif: 'bayi-baglanti', metin: 'Varsayılan yap' })
        if (varsayilanYap) {
          varsayilanYap.addEventListener('click', () =>
            islem(() => api('/hesap/adresler/' + a.id, { yontem: 'POST', jetonlu: true, govde: Object.assign({}, a, { varsayilan: true }) }), 'Varsayılan adres değiştirildi.')
          )
        }
        return oge('div', { sinif: 'bayi-adres' }, [
          oge('b', {}, [a.baslik, a.varsayilan ? oge('span', { sinif: 'bayi-rozet', metin: 'Varsayılan' }) : null]),
          oge('span', { metin: musteriAdresMetni(a) }),
          a.telefon ? oge('span', { metin: a.telefon }) : null,
          oge('div', { sinif: 'bayi-adres__islem' }, [duzenle, varsayilanYap, sil])
        ])
      })
      doldur([baslik, oge('div', { sinif: 'bayi-adresler' }, kartlar)])
    }

    function sifreGoster() {
      temizle()
      const form = oge('form', { sinif: 'bayi-form bayi-form--dar', novalidate: true }, [
        alan('Mevcut şifre', girdi('mevcut', '', { type: 'password', autocomplete: 'current-password', required: true })),
        alan('Yeni şifre', girdi('yeni', '', { type: 'password', autocomplete: 'new-password', minlength: 8, maxlength: 100, required: true }), 'En az 8 karakter.'),
        alan('Yeni şifre (tekrar)', girdi('tekrar', '', { type: 'password', autocomplete: 'new-password', minlength: 8, maxlength: 100, required: true })),
        oge('div', {}, [gonderDugmesi('Şifremi değiştir')])
      ])
      form.addEventListener('submit', (olay) => {
        olay.preventDefault()
        formGonder(form, async () => {
          const e = form.elements
          if (e.yeni.value.length < 8) throw new Error('Yeni şifre en az 8 karakter olmalıdır.')
          if (e.yeni.value !== e.tekrar.value) throw new Error('Yeni şifreler birbiriyle aynı değil.')
          const veri = await api('/hesap/sifre-degistir', { yontem: 'POST', jetonlu: true, govde: { mevcut: e.mevcut.value, yeni: e.yeni.value } })
          depoYaz(localStorage, JETON, veri.jeton)
          form.reset()
          basari('Şifreniz değiştirildi. Diğer cihazlardaki oturumlarınız kapatıldı.')
        })
      })
      doldur([bolumBasligi('Şifre değiştir'), form])
    }

    const gosterenler = { siparisler: siparisleriGoster, profil: profilGoster, adresler: adresListesi, sifre: sifreGoster }

    function sekmeAc(ad) {
      sekmeler.forEach((s) => {
        const secili = s.dataset.bayiSekme === ad
        s.classList.toggle('secili', secili)
        s.setAttribute('aria-selected', String(secili))
      })
      bolum.querySelector('[data-bayi-yeni]').hidden = true
      gosterenler[ad]()
    }

    sekmeler.forEach((s) => s.addEventListener('click', () => sekmeAc(s.dataset.bayiSekme)))

    kunyeYaz()
    const hosgeldin = new URLSearchParams(window.location.search).get('hosgeldin')
    api('/hesap', { jetonlu: true })
      .then((veri) => bilgiKaydet(veri.hesap))
      .catch((hata) => (hata.durum === 401 ? oturumuKapat(ayar.sayfalar.giris) : null))
      .then(() => {
        if (!jeton()) return
        siparisleriGoster()
        if (!hosgeldin) return
        const kutu = bolum.querySelector('[data-bayi-yeni]')
        kutu.textContent = 'Üyeliğiniz oluşturuldu. ' + (bilgi.email || 'E-posta') + ' adresine bir doğrulama bağlantısı gönderdik; doğruladıktan sonra siparişlerinizi buradan izleyebilirsiniz.'
        kutu.hidden = false
        window.history.replaceState(null, '', window.location.pathname)
      })
  }

  async function dogrula(bolum) {
    const token = new URLSearchParams(window.location.search).get('token') || ''
    try {
      if (!/^[a-f0-9]{64}$/.test(token)) throw new Error('Doğrulama bağlantısı eksik ya da hatalı. E-postanızdaki bağlantıya yeniden tıklayın.')
      await api('/e-posta-dogrula', { yontem: 'POST', govde: { token } })
      bolum.querySelector('[data-bayi-basarili]').hidden = false
      const hesap = musteriMi() ? bilgiAl() : null
      if (hesap) bilgiYaz(Object.assign({}, hesap, { epostaDogrulandi: true }))
    } catch (hata) {
      mesajGoster(bolum, hata.message)
    } finally {
      bolum.querySelector('[data-bayi-bekleme]').hidden = true
      window.history.replaceState(null, '', window.location.pathname)
    }
  }

  async function baslat() {
    const durum = await esitle(false).catch((hata) => {
      console.error(hata)
      return Boolean(ayar.oturum)
    })
    if (durum === 'yenilendi') return
    yoklamayiBaslat()
    sepetiIzle()
    const bolumler = {}
    document.querySelectorAll('[data-bayi-bolum]').forEach((b) => {
      bolumler[b.dataset.bayiBolum] = b
    })
    if (bolumler.hesabim) hesabim(bolumler.hesabim)
    if (bolumler.giris && girisSayfasi() && ((bayiMi() && ayar.oturum) || musteriMi())) {
      window.location.href = ayar.sayfalar.hesabim
    }
    if (bolumler.kayit && jeton()) window.location.href = ayar.sayfalar.hesabim
    if (bolumler.dogrula) dogrula(bolumler.dogrula)
    const donus = new URLSearchParams(window.location.search).get('donus') || ''
    if (/^\/(?!\/)/.test(donus)) {
      document.querySelectorAll('a[data-bayi-donuslu]').forEach((a) => {
        a.setAttribute('href', a.getAttribute('href') + '?donus=' + encodeURIComponent(donus))
      })
    }
    if (musteriMi()) {
      document.querySelectorAll('[data-bayi-hesap-baglantisi]').forEach((a) => {
        a.setAttribute('href', ayar.sayfalar.hesabim)
        a.setAttribute('aria-label', 'Hesabım')
        a.setAttribute('title', 'Hesabım')
        const etiket = a.querySelector('.hdt-navbar-mobile__label')
        if (etiket) etiket.textContent = 'Hesabım'
      })
    }
    if (bolumler.sifre && new URLSearchParams(window.location.search).get('token')) {
      bolumler.sifre.querySelector('[data-bayi-form="sifre-talep"]').hidden = true
      bolumler.sifre.querySelector('[data-bayi-form="sifre-yenile"]').hidden = false
    }
    if (ayar.oturum) {
      kuralNotlariniYaz()
      let bekleyen = null
      new MutationObserver(() => {
        clearTimeout(bekleyen)
        bekleyen = setTimeout(kuralNotlariniYaz, 200)
      }).observe(document.body, { childList: true, subtree: true })
    }
  }

  baslat()
})()
